import React from 'react';

export const AppContext = React.createContext(
    {
        handleAxiosException: null,
        addMessage: null,
        clearMessages: null,
        locale: 'en-EN',
        user: null
    }
);

export const CrudContext = React.createContext(
    {
        i18nGroup: '',
    }
);

export const CrudDetailsContext = React.createContext(
    {
        entity: null,
        submitted: false,
        validationMethods: []
    }
);
